export const RENEW_PASSWORD_FORM_ID = 'renew-password-form-title';
export const TITLE_ID = 'form-title';
export const PASSWORD_MAX_LENGTH = 8;
